<div class="d-flex align-items-center flex-wrap gap-2">
  <div class="search-wrapper">
    <i class="fas fa-search search-icon"></i>
    <input
      type="text"
      class="form-control search-input"
      [value]="searchTerm"
      [placeholder]="'Settings::Notifications:SearchPlaceholder' | abpLocalization"
      (input)="onSearchInput($event)" />
  </div>

  <button type="button" class="btn ca-btn ca-btn-neutral" (click)="expandAll()">
    {{ 'Settings::Notifications:ExpandAll' | abpLocalization }}
  </button>

  <button type="button" class="btn ca-btn ca-btn-neutral" (click)="collapseAll()">
    {{ 'Settings::Notifications:CollapseAll' | abpLocalization }}
  </button>

  <small class="text-muted ms-auto">
    <ng-container *ngIf="!isSearching">
      {{ 'Settings::Notifications:Count' | abpLocalization: totalItemCountText }}
    </ng-container>
    <ng-container *ngIf="isSearching">
      {{ 'Settings::Notifications:CountFiltered' | abpLocalization: filteredItemCountText }}
    </ng-container>
  </small>
</div>

<hr />

<table
  mat-table
  [dataSource]="dataSource"
  [trackBy]="trackByCategoryCode"
  class="matrix-table mt-2"
  multiTemplateDataRows>
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef class="col-expand"></th>
    <td mat-cell *matCellDef="let cat" class="col-expand">
      <i
        class="fas"
        [class.fa-chevron-down]="!expanded[cat.code]"
        [class.fa-chevron-up]="expanded[cat.code]"></i>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'Settings::Notifications:Notification' | abpLocalization }}
    </th>
    <td mat-cell *matCellDef="let cat" class="fw-semibold">{{ getCategoryLabel(cat) }}</td>
  </ng-container>

  <ng-container matColumnDef="inApp">
    <th mat-header-cell *matHeaderCellDef class="col-channel text-center">
      {{ 'Settings::Notifications:InApp' | abpLocalization }}
    </th>
    <td mat-cell *matCellDef="let cat" class="col-channel"></td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef class="col-channel text-center">
      {{ 'Settings::Notifications:Email' | abpLocalization }}
    </th>
    <td mat-cell *matCellDef="let cat" class="col-channel"></td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let cat" [colSpan]="displayedColumns.length" class="detail-cell">
      <div
        class="detail-wrapper"
        [@detailExpand]="expanded[cat.code] ? 'expanded' : 'collapsed'"
        [attr.inert]="expanded[cat.code] ? null : ''"
        [attr.aria-hidden]="expanded[cat.code] ? null : 'true'">
        <table
          mat-table
          [dataSource]="cat.items"
          [trackBy]="trackByNotificationType"
          class="detail-table">
          <ng-container matColumnDef="name">
            <td mat-cell *matCellDef="let item" class="item-name py-2">
              <div>{{ item.displayName }}</div>
              <small class="text-muted">{{ item.description }}</small>
            </td>
          </ng-container>

          <ng-container matColumnDef="inApp">
            <td mat-cell *matCellDef="let item" class="col-channel">
              <div
                class="form-check form-switch d-flex justify-content-center p-0 mb-0"
                *ngIf="item.supportsInApp">
                <mat-slide-toggle
                  [checked]="item.inAppEnabled"
                  [disabled]="disabled"
                  (change)="onToggle(item, 'inApp', $event)"></mat-slide-toggle>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <td mat-cell *matCellDef="let item" class="col-channel">
              <div
                class="form-check form-switch d-flex justify-content-center p-0 mb-0"
                *ngIf="item.supportsEmail">
                <mat-slide-toggle
                  [checked]="item.emailEnabled"
                  [disabled]="disabled"
                  (change)="onToggle(item, 'email', $event)"></mat-slide-toggle>
              </div>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let item; columns: detailDisplayedColumns"></tr>
        </table>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr
    mat-row
    *matRowDef="let cat; columns: displayedColumns"
    class="main-row"
    (click)="toggleCategory(cat)"></tr>
  <tr mat-row *matRowDef="let cat; columns: ['expandedDetail']" class="detail-row"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell p-3 text-center text-muted" [colSpan]="displayedColumns.length">
      {{ 'Settings::Notifications:NoResult' | abpLocalization }}
    </td>
  </tr>
</table>
